import React from "react"
import { TextField } from "@mui/material"
import { styled } from '@mui/material/styles'
import { blueGrey } from "@mui/material/colors"

interface ExperienceRatingOpenResponseProps {
  disabled: boolean
  response?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.default,
      '&:hover fieldset': {
        borderColor: blueGrey[200]
      },
      '&.Mui-focused fieldset': {
        borderColor: blueGrey[200],
        borderWidth: 1
      }
    },
    '& .MuiInputBase-input::placeholder': {
      fontWeight: theme.typography.body2.fontWeight,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.h5.lineHeight,
      color: blueGrey[500],
      opacity: 0.8
    },
    '& .MuiInputBase-input': {
      fontWeight: theme.typography.body2.fontWeight,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.h5.lineHeight,
      color: blueGrey[500],
      opacity: 1
    }
  }))

const ExperienceRatingOpenResponse: React.FC<
  ExperienceRatingOpenResponseProps
> = ({ disabled, response, onChange }) => {

  return (
    <StyledTextField
      placeholder="Let us know how clear the content was, how challenging it felt, or how helpful the instruction was — we'd love to hear it all."
      variant="outlined"
      fullWidth
      multiline
      rows={3}
      value={response}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default ExperienceRatingOpenResponse